import { NgModule } from '@angular/core';
import { DxFormControlDirective } from './form-control.directive';

@NgModule({
  declarations: [DxFormControlDirective],
  exports: [DxFormControlDirective]
})
export class DxFormControlDirectiveModule {}
